"use strict";
/**
 * @copyright 2020 Microsoft Corporation
 */
var $dyn;
(function ($dyn) {
    Globalize.addCultureInfo("en", {
        messages: {
            HelpMenu_ShowHelp: "Show help",
            HelpPane_Title: "Help"
        }
    });
    var ax;
    (function (ax) {
        /**
         * Help pane dialog window
         */
        // tslint:disable-next-line
        var helpPane;
        (function (helpPane) {
            /**
             * Close helpPane dialog
             */
            function close() {
                if (helpPane.pane) {
                    $dyn.shell.hideAsidePane(helpPane.pane.targetElement);
                }
            }
            helpPane.close = close;
            /**
             * Open helpPane dialog
             */
            function open() {
                if (!helpPane.pane) {
                    helpPane.pane = {
                        name: "HelpPane",
                        role: "Dialog",
                        templateId: "HelpPane"
                    };
                    $dyn.shell.createForm(helpPane.pane);
                    var context_1 = $dyn.context(helpPane.pane.targetElement);
                    context_1.DisplayTarget = $dyn.forms.DisplayTarget.AsidePane;
                    // This is a singleton form, so we do not want to auto close it
                    context_1.PreventAutoClose(true);
                }
                else {
                    if (helpPane.refreshHelp) {
                        helpPane.refreshHelp();
                    }
                }
                $dyn.shell.open({ form: $dyn.context(helpPane.pane.targetElement) });
            }
            helpPane.open = open;
        })(helpPane = ax.helpPane || (ax.helpPane = {}));
        /**
         * Defines the keyboard shortcuts bound to the helpPane
         */
        // tslint:disable:object-literal-sort-keys
        ax.Shortcuts = {
            OpenHelpPane_Alternative: {
                Keys: { alt: true, shift: true, keyCode: $dyn.ui.KeyCodes.letterA },
                Handler: function () {
                    if ($dyn.shell.hasRestrictedInternet() === false) {
                        $dyn.shell.openHelpPane();
                    }
                },
                Description: $dyn.label("HelpMenu_ShowHelp"),
                Category: $dyn.ui.ShortcutCategory.Navigate
            },
            OpenHelpPane_Primary: {
                Keys: { ctrl: true, shift: true, keyCode: $dyn.ui.KeyCodes.forwardslash },
                Handler: function () {
                    if ($dyn.shell.hasRestrictedInternet() === false) {
                        $dyn.shell.openHelpPane();
                    }
                },
                Description: $dyn.label("HelpMenu_ShowHelp"),
                Category: $dyn.ui.ShortcutCategory.Navigate
            }
        };
        // tslint:enable:object-literal-sort-keys
        $dyn.shell.openHelpPane = helpPane.open;
        $(document).on("keydown", function (event) {
            if (!event.isPropagationStopped()) {
                $dyn.util.handleShortcuts($dyn.ax, event);
            }
        });
    })(ax = $dyn.ax || ($dyn.ax = {}));
})($dyn || ($dyn = {}));

//# sourceMappingURL=HelpPane.js.map
